module.exports = __webpack_public_path__ + "img/solutionImg3.990d6cf5.png";